/* SolutionPermsMap.js */

"use strict";
const SOLUTION_USER_PERM_MAP = {
    classic: "modelEditorAccess",
    workflow_explorer: "workflowAccess",
    config_drift: "configDriftAndAuditAccess",
    data_export: "dataExportAccess",
    os_manager: "osmAccess",
    device_manager: "deviceManagerAccess",
    file_server: "fileServerAccess",
    work_triggers: "scheduleAccess",
    solutions_management: "solutionManagementAccess",
    system_settings: false,
    dashboard: "dashboardAccess",
    data_explorer: "dataExplorerAccess",
    WorkflowExplorer: "workflowAccess",
    ConfigDrift: "configDriftAndAuditAccess",
    DataExport: "dataExportAccess",
    OsManager: "osmAccess",
    DeviceManager: "deviceManagerAccess",
    FileServer: "fileServerAccess",
    WorkTriggers: "scheduleAccess",
    Packages: "solutionManagementAccess",
    Settings: false,
    DataExplorer: "dataExplorerAccess",
    rpa: "rpaWorkflowAccess",
    topology: "topologyAccess",
    version_control: "versionControlAccess",
    VersionControl: "versionControlAccess",
};

module.exports = SOLUTION_USER_PERM_MAP;
